import { legacy_createStore as createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import rootReducer from '@reducers/index';
import { middleware } from '@middlewares';

function configureStore(initialState?: ReturnType<typeof rootReducer>) {
  const store = createStore(
    rootReducer,
    initialState,
    composeWithDevTools(middleware),
  );
  return store;
}

export default configureStore;
